/* @flow */

export const REGISTER_LOAN_HISTORY_REQUEST = 'REGISTER_LOAN_HISTORY_REQUEST';
export const REGISTER_LOAN_HISTORY_SUCCESS = 'REGISTER_LOAN_HISTORY_SUCCESS';
export const REGISTER_LOAN_HISTORY_FAILURE = 'REGISTER_LOAN_HISTORY_FAILURE';

export function success(payload) {
  return (dispatch) => {
    dispatch({
      type: REGISTER_LOAN_HISTORY_SUCCESS,
      payload,
    });
  };
}

export function failure(resource) {
  return (dispatch) => {
    dispatch({
      type: REGISTER_LOAN_HISTORY_FAILURE,
      payload: resource,
    });
  };
}

export default function registerLoanHistory(params) {
  return (dispatch) => {
    dispatch({
      type: REGISTER_LOAN_HISTORY_REQUEST,
      payload: params,
    });
  };
}
